var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStampCounter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "71px",
    viewBox: "0 0 88 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/stampCounter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stampCounter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stampYellow",
    transform: "translate(20.000000, 2.000000)",
    stroke: "#000000",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,66.8669562 C22.2006873,46.3965878 45.1585942,23.3091216 65.8621693,6 C66.2508472,26.1076024 65.4734914,47.096208 64.8775187,67.1778985 C44.277591,67.5665764 23.5740158,67.2815459 3,66.8669562 Z",
    id: "SHADOW",
    fill: "#000000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.61852778e-14,60.8669562 C19.2006873,40.3965878 42.1585942,17.3091216 62.8621693,1.0658141e-14 C63.2508472,20.1076024 62.4734914,41.096208 61.8775187,61.1778985 C41.277591,61.5665764 20.5740158,61.2815459 -4.61852778e-14,60.8669562 Z",
    fill: "#FABE0A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "stampPurple",
    transform: "translate(2.000000, 1.792705)",
    stroke: "#000000",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,66.8669562 C22.2006873,46.3965878 45.1585942,23.3091216 65.8621693,6 C66.2508472,26.1076024 65.4734914,47.096208 64.8775187,67.1778985 C44.277591,67.5665764 23.5740158,67.2815459 3,66.8669562 Z",
    id: "SHADOW",
    fill: "#000000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.61852778e-14,60.8669562 C19.2006873,40.3965878 42.1585942,17.3091216 62.8621693,1.0658141e-14 C63.2508472,20.1076024 62.4734914,41.096208 61.8775187,61.1778985 C41.277591,61.5665764 20.5740158,61.2815459 -4.61852778e-14,60.8669562 Z",
    fill: "#A578CF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.89,
    transform: "translate(7.000000, 9.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1915671,2.87152565 C26.5134808,1.76349098 19.9093566,1.40263677 15.1358493,3.67389559 C6.16603733,7.21026679 -0.735114416,17.0063971 1.38621031,26.8831889 C2.49586709,38.3456166 13.9140914,47.9245805 25.2264189,45.6681804 C31.5040234,44.9358586 37.9437767,41.7949583 41.2258262,35.9597335 C44.3876184,30.5443832 45.2768714,25.5496804 44.9294384,20.9397079 C44.3876184,13.750479 40.0210171,6.24067992 30.1915671,2.87152565 Z",
    id: "SHADOW",
    strokeWidth: 2.5,
    fill: "#000000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1915671,0.871525654 C25.5134808,-0.236509021 18.9093566,-0.597363225 14.1358493,1.67389559 C5.16603733,5.21026679 -1.73511442,15.0063971 0.386210312,24.8831889 C1.49586709,36.3456166 12.9140914,45.9245805 24.2264189,43.6681804 C30.5040234,42.9358586 36.9437767,39.7949583 40.2258262,33.9597335 C43.3876184,28.5443832 44.2768714,23.5496804 43.9294384,18.9397079 C43.3876184,11.750479 39.0210171,4.24067992 29.1915671,0.871525654 Z",
    id: "miniCounter",
    strokeWidth: 1.5,
    fill: "#576891",
    strokeDasharray: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampCounter);
export default __webpack_public_path__ + "static/media/stampCounter.3706c1dbf4b50773cac432429b4a22f9.svg";
export { ForwardRef as ReactComponent };